export class PrintDestination {
  object = 'printDestination';
  name: string;
  type: string;

  get prefixedName(): string {
    return `${this.type.toLowerCase()}:${this.name}`;
  }
}
